import { Spine } from "@esotericsoftware/spine-pixi-v8";
//import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";

export class ReelFrame {
    private anim: Spine;
    private currentAnimName: string | null = null;

    constructor(skel: string, atlas: string) {
        this.init(skel, atlas);
    }

    private init(skel: string, atlas: string): void {
        this.anim = Spine.from({
            skeleton: skel,
            atlas: atlas
        });
        this.anim.label = "reelFrame";
        this.playAnimation("reel", true);
    }

    public getAnim() {
        return this.anim;
    }

    public playAnimation(animationName: string, loop: boolean = true): void {
        const current = this.anim.state.getCurrent(0)?.animation?.name ?? this.currentAnimName;
        if (current === animationName) return;

        this.currentAnimName = animationName;
        this.anim.state.setAnimation(0, animationName, loop);
    }

    // public upgrade(rowsCount : number, callback: () => void) {
    //     const timescale = isSuperQuickBtnOnGlobal ? 2 : 1;
    //     this.anim.state.timeScale = timescale;
    //     this.anim.state.setAnimation(0, "5x" + rowsCount, false);
    //     this.anim.state.addAnimation(0, "5x" + rowsCount + "_loop", false);
    //     this.anim.state.addListener({
    //         complete: (entry) => {
    //             if (entry.animation.name === "5x" + rowsCount) {
    //                 this.anim.state.clearListeners();
    //                 this.anim.state.timeScale = 1;
    //                 callback?.();
    //             }
    //         }
    //     });
    // }

    public destroy() {
        if (!this.anim.destroyed)
            this.anim.destroy();
    }
}
